import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { gray } from '@kizen/kds/Colors';
import Icon from '../../Kizen/Icon';

const ColorlessIcon = (props) => <Icon color={null} {...props} />;

export default styled(ColorlessIcon)`
  display: inline-flex;
  align-items: center;
  height: auto;
  width: auto;
  color: ${gray['gray-600']};
  ${({ start, end }) => {
    if (!start && !end) {
      return css``;
    }
    const side = start ? 'right' : 'left';
    return css`
      margin-${side}: 10px;
    `;
  }}
  ${({ variant, icon }) => {
    const sizedDimension = icon === 'false' ? 'height' : 'width';
    const otherDimension = sizedDimension === 'height' ? 'width' : 'height';
    return css`
      && svg {
        position: relative;
        color: inherit;
        ${sizedDimension}: ${10 + (variant === 'underline' ? 0 : 2)}px;
        ${otherDimension}: auto;
      }
    `;
  }}
`;
